/**
 * Member Profile Form Component
 *
 * Form for editing member's basic profile information (name, email, phone).
 */

import { Box, TextField } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';

interface MemberProfileFormProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  onChange: (field: string, value: string) => void;
  disabled?: boolean;
}

export function MemberProfileForm({
  firstName,
  lastName,
  email,
  phone,
  onChange,
  disabled = false,
}: MemberProfileFormProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
          label="First Name"
          value={firstName}
          onChange={(e) => onChange('first_name', e.target.value)}
          disabled={disabled}
          fullWidth
          size="small"
        />
        <TextField
          label="Last Name"
          value={lastName}
          onChange={(e) => onChange('last_name', e.target.value)}
          disabled={disabled}
          fullWidth
          size="small"
        />
      </Box>

      <TextField
        label="Email Address"
        type="email"
        value={email}
        onChange={(e) => onChange('email', e.target.value)}
        disabled={disabled}
        fullWidth
        size="small"
      />

      <MuiTelInput
        label="Mobile Phone Number"
        value={phone}
        onChange={(value) => onChange('mobile_phone_num', value)}
        disabled={disabled}
        fullWidth
        size="small"
        defaultCountry="US"
        forceCallingCode
        helperText="Mobile number where this clinician will receive JotPsych updates and notifications"
      />
    </Box>
  );
}
